var map = {
	"./volatility_cn.png": 46072,
	"./volatility_en.png": 77806,
	"./volatility_id.png": 72464,
	"./volatility_ko.png": 54009,
	"./volatility_ph.png": 95231,
	"./volatility_th.png": 16627,
	"./volatility_zh.png": 47137
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94868;